import { useMemo, useState } from "react";
import { buildProgress, sumProgress, updateFileCollection } from "./utils";

export default function useDirectUpload(presignBlobs, uploadFile) {
  const [isLoading, setIsLoading] = useState(false);
  const [errorsByFile, setErrorsByFile] = useState([]);
  const [progressByFile, setProgressByFile] = useState([]);

  const progress = useMemo(
    () => buildProgress(sumProgress(progressByFile)),
    [progressByFile],
  );

  const initUpload = (files) => {
    setProgressByFile(
      files.map(({ size }) => ({ loaded: 0, percent: 0, total: size })),
    );
    setErrorsByFile(files.map(() => null));
    setIsLoading(true);
  };

  const uploadFiles = async (files, blobs) => {
    for (let i = 0; i < blobs.length; i++) {
      const { directUploadUrl, headers } = blobs[i];

      const onProgress = (event) =>
        updateFileCollection(buildProgress(event), i, setProgressByFile);
      const onError = (error) =>
        updateFileCollection(error, i, setErrorsByFile);

      await uploadFile(
        directUploadUrl,
        JSON.parse(headers),
        files[i],
        onProgress,
      ).catch(onError);
    }
  };

  const upload = async (files) => {
    initUpload(files);

    const blobs = await presignBlobs(files).catch((e) => {
      setErrorsByFile(files.map(() => e));
      setIsLoading(false);
    });
    if (!blobs) return;
    await uploadFiles(files, blobs);

    setIsLoading(false);
    return blobs;
  };

  return {
    upload,
    progress,
    progressByFile,
    isLoading,
    errorsByFile,
  };
}
